export default __webpack_public_path__ + "static/media/36t.3a22ed6f.jpg";